export const SALE_PRODUCTS_SET = 'SALE_PRODUCTS_SET';
export const NEW_PRODUCTS_SET = 'NEW_PRODUCTS_SET';
export const POPULAR_PRODUCTS_SET = 'POPULAR_PRODUCTS_SET';
